import React from "react";
import Link from "gatsby-link";
import { slide as Menu } from 'react-burger-menu'

import styles from './Header.css';
import logo from './logo.png';

class Header extends React.Component {

  render() {
    return (
      <div className="Header Container">
        <a className="Header__Logo" href="/" />
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx